import React, { useState } from 'react'
import { Navigate, Link } from 'react-router'
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from '../../../firebase/auth'
import { useAuth } from '../../../contexts/authContext'
import { Row } from 'react-bootstrap'
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { GoldFinderLogo } from '../../branding/GoldFinderLogo'

const PasswordReset = () => {
    const { userLoggedIn } = useAuth()

    const [email, setEmail] = useState('')

    const onSubmit = async (e) => {
        e.preventDefault()
        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
          .then(() => {
            alert("Password reset email sent!")
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ..
          });
    }

 
  return (
        <>
            {userLoggedIn && (<Navigate to={'/'} replace={true} />)}
            <div style={{ height: '100vh' }} className='d-flex align-items-center py-4 bg-body-tertiary'>
                <main class="form-signin w-100 m-auto">
                    <form
                        onSubmit={onSubmit}
                    >
                        <Row>
                            <div className="mb-4 d-flex justify-content-center">
                                {/* Was an <img> pointing at https://map.goldfinder.net.au -
                                    a hardcoded PRODUCTION url, so develop and localhost
                                    both fetched prod's logo over the network and would
                                    show the old mark forever. */}
                                <GoldFinderLogo height={44} />
                            </div>
                        </Row>
                        <Row>

                        </Row>

                        <div class="form-floating mb-3">
                            <input
                                className="form-control"
                                type="email"
                                autoComplete='email'
                                required
                                placeholder="name@example.com"
                                id="floatingInput"
                                value={email} onChange={(e) => { setEmail(e.target.value) }}
                            />


                            <label for="floatingInput">Email address</label>
                        </div>




                        <button
                            type="submit"
                            className={'btn w-100 py-2 gf-auth-submit'}
                        >
                            Reset Password
                        </button>


                        <div class="form-check text-start my-3">
                            Already Registered? <a href='/login'>Sign In</a>
                        </div>

                        <div class="form-check text-start my-3">
                            Looking to  <a href='/signup'>create an account</a>?
                        </div>

                        <p class="mt-5 mb-3 text-body-secondary">&copy; {new Date().getFullYear()} GoldFinder</p>
                    </form>
                </main>
            </div>
        </>
    )


}

export default PasswordReset